import { render, staticRenderFns } from "./AffiliateWelcomePage.vue?vue&type=template&id=6f0def25&scoped=true&"
import script from "./AffiliateWelcomePage.vue?vue&type=script&lang=js&"
export * from "./AffiliateWelcomePage.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateWelcomePage.vue?vue&type=style&index=0&id=6f0def25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0def25",
  null
  
)

export default component.exports